"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryInitSession = exports.disposeSession = exports.initSession = void 0;
const config_1 = require("../../utils/config");
const eventManager_1 = require("../../utils/eventManager");
const GqlError_1 = require("../../utils/GqlError");
let $id_token = '';
let $access_token = '';
let $email = '';
function initSession(id_token, access_token, email) {
    return __awaiter(this, void 0, void 0, function* () {
        $id_token = id_token;
        $access_token = access_token;
        $email = email;
        try {
            yield fetch(`${config_1.config[config_1.getEnv()].jerichoUrl}/auth/_ajax/auth/v1/initsession`, {
                credentials: 'include',
                method: 'post',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    clientId: 'CHGG',
                    tokens: {
                        id_token,
                        access_token,
                    },
                    email,
                }),
            });
            $id_token = '';
            $access_token = '';
            $email = '';
        }
        catch (e) {
            e.apiName = 'initSession';
            const err = GqlError_1.getError(e);
            if (err instanceof GqlError_1.PxError) {
                throw err;
            }
            eventManager_1.triggerError('init session', err);
        }
    });
}
exports.initSession = initSession;
/* istanbul ignore next */
function retryInitSession() {
    return initSession($id_token, $access_token, $email);
}
exports.retryInitSession = retryInitSession;
function disposeSession() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield fetch(`${config_1.config[config_1.getEnv()].jerichoUrl}/auth/_ajax/auth/v1/disposesession`, {
                credentials: 'include',
                method: 'post',
            });
        }
        catch (e) {
            eventManager_1.triggerError('dispose session', e);
        }
    });
}
exports.disposeSession = disposeSession;
